import React from "react";
import { Mail, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Premium activation notice shown to owners/managers whose restaurant is
 * blocked (trial_expired / payment_open / suspended). The Pinetti voice:
 * calm, restrained, no panic colors.
 */
const COPY = {
  trial_expired: {
    eyebrow: "Testphase",
    title: "Ihre SONARA-Testphase ist abgelaufen.",
    body:  "Aktivieren Sie Ihr Konto, um Ihr Haus weiterhin mit SONARA zu führen. Ihre Daten bleiben vollständig erhalten.",
  },
  payment_open: {
    eyebrow: "Zahlung",
    title: "Ihre Zahlung steht aus.",
    body:  "Sobald Ihre Zahlung bei uns eingegangen ist, schaltet das SONARA-Team Ihr Konto wieder frei. Ihre Daten bleiben unberührt.",
  },
  suspended: {
    eyebrow: "Konto pausiert",
    title: "Ihr SONARA-Konto ist derzeit pausiert.",
    body:  "Bitte kontaktieren Sie das SONARA-Team, um Ihr Konto wieder zu aktivieren.",
  },
};

export default function TrialBlockedNotice({ code }) {
  const c = COPY[code] || COPY.trial_expired;
  const { user } = useAuth();
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-[var(--bg-rooftop)]/95 backdrop-blur-md p-6"
      data-testid="trial-blocked-notice"
    >
      <div
        className="relative w-full max-w-xl rounded-md p-10 sm:p-14"
        style={{
          background: "var(--bg-velvet)",
          boxShadow: "0 1px 0 rgba(184,150,86,0.10) inset, 0 60px 120px -40px rgba(0,0,0,0.7)",
        }}
      >
        <span aria-hidden className="absolute top-0 left-12 right-12 h-px brass-line opacity-80" />
        <div className="text-[10px] tracking-[0.42em] uppercase text-[var(--gold-warm)] mb-6 inline-flex items-center gap-2">
          <Clock className="w-3 h-3" strokeWidth={1.6} /> {c.eyebrow}
        </div>
        <h2 className="font-editorial italic font-light text-3xl sm:text-4xl leading-[1.15] tracking-tight text-[var(--text-primary)] mb-6">
          {c.title}
        </h2>
        <p className="text-[var(--text-secondary)] leading-[1.75] font-light text-[15px] max-w-md mb-10">
          {c.body}
        </p>
        <div className="flex flex-wrap items-center gap-5">
          <a
            href="mailto:hello@sonarabooking.ch"
            className="btn-primary text-[11px] tracking-[0.22em] uppercase inline-flex items-center gap-2"
            data-testid="trial-contact-btn"
          >
            <Mail className="w-3.5 h-3.5" strokeWidth={1.6} /> SONARA kontaktieren
          </a>
          {user && (
            <span className="text-[11px] tracking-[0.22em] uppercase text-[var(--text-muted)]">
              {user.name}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
